export default "__VITE_ASSET__c2b80a07__"